import { lazy } from "react";
import { Outlet } from "react-router-dom";
import { userChildrenRoutes } from "./userChildrenRoutes";

const NotFoundPage = lazy(() => import('../../pages/404NotFound').then(module => ({ default: module.NotFound })));

interface RouteItem {
    path: string;
    element: JSX.Element;
}

const emissionRoutes = {
    path: '/usuario',
    element: <Outlet />,
    errorElement: <NotFoundPage />,
    children: [
      ...userChildrenRoutes.map(({ path, element }: RouteItem) => ({
        path,
        element,
      })),
    ],
  }
;

export default emissionRoutes;